import { MutationTuple, useMutation } from '@apollo/client';
import { SAVE_STEP_RESPONSE_MUTATION } from 'graphql/steps/mutations/saveStepResponse.gql';
import { SaveStepResponseMutation, SaveStepResponseMutationVariables } from '__generated__/graphql';

export default function useMutationSaveStepResponse(): MutationTuple<
  SaveStepResponseMutation,
  SaveStepResponseMutationVariables
> {
  return useMutation(SAVE_STEP_RESPONSE_MUTATION);
}
